"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseCaseError = void 0;
var UseCaseError = /** @class */ (function (_super) {
    __extends(UseCaseError, _super);
    function UseCaseError(code, message, status, details) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.status = status;
        _this.details = details || '';
        return _this;
    }
    UseCaseError.create = function (code, details) {
        var error = this.errors[code];
        if (!error) {
            throw new Error('There is no such error code in the system');
        }
        error.details = details || error.details;
        return error;
    };
    UseCaseError.errors = {
        invalidData: new UseCaseError('invalidData', 'Provided data is not valid', 400),
        notFound: new UseCaseError('notFound', 'Requested object is not found', 404),
        problemInProcess: new UseCaseError('problemInProcess', 'Problem occurred in process', 500),
    };
    return UseCaseError;
}(Error));
exports.UseCaseError = UseCaseError;
//# sourceMappingURL=UseCaseError.js.map